// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"5c2cae6f","264":"2a4ea7ec","477":"b1fde586","584":"78e2de4d","658":"fba37667","775":"147d9c49","805":"d0dec3e1","937":"7f7d09e8","947":"f25ec52c"}[chunkId] + ".chunk.css";
};